import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-black text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Terms and Conditions for Slyder</h1>
        <p className="text-gray-400 mb-8">Last Updated: January 30, 2026</p>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">1. Acceptance of Terms & Age Requirement</h2>
            <p className="leading-relaxed mb-4">
              By accessing, downloading, or using the Slyder mobile application (the "Service"), you accept and agree to be bound by these Terms and Conditions ("Terms") issued by Ethereal Labs Private Limited ("we," "us," or "our").
            </p>
            <p className="leading-relaxed">
              You must be 18 years of age or older (or the age of legal majority in your jurisdiction) to use this Service. By creating an account, you represent and warrant that you meet this age requirement. If you do not meet this requirement, you must not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">2. AI Content Disclaimer</h2>
            <p className="leading-relaxed mb-4">
              Slyder is an AI chat service. Content generated by the AI is not created by humans and does not represent the views of Ethereal Labs Private Limited.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>User Risk:</strong> You use the Service at your own risk. Materials are provided on an 'as is' basis.</li>
              <li><strong>Accuracy:</strong> We make no warranties regarding the accuracy, reliability, or suitability of AI-generated content. You may encounter content that is inaccurate or offensive despite our filters.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">3. Subscriptions, Payments, and Cancellations</h2>
            <ul className="list-disc pl-6 space-y-3">
              <li>
                <strong>Payment Processor:</strong> We use third-party payment processor, a third-party processor. Your payments are subject to the third-party payment processor's Terms of Service and Privacy Policy.
              </li>
              <li>
                <strong>Billing:</strong> Subscriptions automatically renew at the end of each billing period unless cancelled. You authorize charges to your designated payment method via a third-party payment processor.
              </li>
              <li>
                <strong>Google Play Disclaimer:</strong> Because third-party payment processor processes payments, your subscription is NOT managed by the Google Play Store. You cannot use Google Play balance or the Google Play subscription center for management. All billing matters must be handled within the Slyder app.
              </li>
              <li>
                <strong>Cancellations:</strong> Cancel anytime via the 'FAQ' section in the app. To avoid renewal charges, you must cancel at least 24 hours before your renewal date.
              </li>
              <li>
                <strong>Refunds:</strong> All purchases are final and non-refundable. We do not provide credits for partially used periods, except where mandatorily required by local consumer law.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">4. User Conduct and Prohibited Content</h2>
            <p className="mb-4">You are solely responsible for your prompts. You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Generate pornographic, graphically nude, or sexually explicit acts (suggestive themes are permitted).</li>
              <li>Request sexual violence, exploitation, or non-consensual content.</li>
              <li>Create hateful, discriminatory, or harassing content.</li>
              <li>Promote illegal drugs or activities.</li>
              <li>Attempt to bypass or "jailbreak" content filters or security systems.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">5. Enforcement and In-App Penalties</h2>
            <p className="leading-relaxed mb-4">
              We reserve the right to enforce these Terms at our sole discretion.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Penalty System:</strong> Repeated attempts to generate prohibited content may result in the deduction of in-app points, currency, or earned items.</li>
              <li><strong>Termination:</strong> Severe or repeated violations may lead to the permanent termination of your account without notice.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">6. Use License</h2>
            <p className="leading-relaxed mb-4">
              Permission is granted for a limited, non-transferable, revocable license to use the Slyder application for personal, non-commercial use on any mobile device that you own or control.
            </p>
            <ul className="list-disc pl-6 space-y-3">
              <li>
                <strong>For iOS Users:</strong> This license is subject to the Apple Standard End User License Agreement (EULA). You agree that this agreement is between you and Ethereal Labs Private Limited only, and not Apple. Ethereal Labs Private Limited is solely responsible for the app and its content.
              </li>
              <li>
                <strong>For Android Users:</strong> This license is subject to the Google Play Terms of Service. By downloading and using the app, you agree to comply with the usage rules set forth by the Google Play Store.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">7. Limitation of Liability</h2>
            <p className="leading-relaxed">
              In no event shall Ethereal Labs Private Limited or its suppliers be liable for any damages (including loss of data, profit, or emotional/psychological harm) arising out of the use or inability to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">8. Changes to These Terms</h2>
            <p className="leading-relaxed">
              We may modify these Terms at any time. Continued use of Slyder after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">9. Contact Information</h2>
            <p className="mb-4">For questions regarding these Terms, please contact:</p>
            <div className="space-y-2">
              <p><strong>Company:</strong> Ethereal Labs Private Limited</p>
              <p><strong>Address:</strong> F.No.205, 8-2-644/1/205, D'Desks, Hiline Complex, Road No.12, Banjara Hills, Hyderabad, Telangana, 500034.</p>
              <p><strong>Email:</strong> <a href="mailto:admin@slyderapp.com" className="text-purple-400 hover:text-purple-300 transition-colors">admin@slyderapp.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
